import {Directive, HostListener} from '@angular/core';
import {MatMenuTrigger} from '@angular/material/menu';

/**
 * Fermeture des menus d'une barre de filtres à chips (mat-menu sans backdrop) :
 * un clic hors de la barre et des overlays ferme tous les menus, l'ouverture d'un
 * menu ferme les autres. Partagé entre les résultats de recherche et la liste /
 * carte des favoris.
 */
@Directive()
export abstract class FilterMenusBase {

    // Zones « intérieures » : un clic dedans ne ferme pas les menus.
    // .cdk-overlay-pane : un clic dans l'overlay (panneau, marge interne du pane
    // pendant l'animation…) n'est jamais un clic « à l'extérieur ».
    protected filterMenuInsideSelectors = ['.filter-bar', '.cdk-overlay-pane'];

    /** Triggers des menus de la barre (surchargé par chaque page qui a des chips) */
    protected filterMenuTriggers(): MatMenuTrigger[] {
        return [];
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        const target = event.target as HTMLElement;
        // Cible détachée du DOM (ex : ngx-slider recrée ses éléments pendant un drag) :
        // closest() ne remonte plus jusqu'à l'overlay, on ignorerait à tort un clic intérieur
        if (!target.isConnected) {
            return;
        }
        if (this.filterMenuInsideSelectors.every(s => !target.closest(s))) {
            this.closeAllFilterMenus();
        }
    }

    closeAllFilterMenus(except?: MatMenuTrigger) {
        this.filterMenuTriggers()
            .filter(t => t && t !== except && t.menuOpen)
            .forEach(t => t.closeMenu());
    }

    onFilterMenuOpened(trigger: MatMenuTrigger) {
        this.closeAllFilterMenus(trigger);
    }
}
